import { api } from "@/frontend/services/api";
import type {
  FixtureResponseDTO,
  FixturesPaginatedResponseDTO,
  KnockoutTreeResponseDTO,
  ImportFixturesFromCatalogRequestDTO,
  ImportFixturesFromCatalogResponseDTO,
  UpdateFixtureRequestDTO,
  CreateFixtureRequestDTO,
  ApiResponse,
  FixtureQueryDTO,
  FixtureWithPredictionQueryDTO,
  FixturesWithPredictionsPaginatedResponseDTO,
} from "@/shared/dto";

const BASE_URL = "/fixtures/private";

export const fixtureService = {
  create: (data: CreateFixtureRequestDTO) =>
    api.post<ApiResponse<FixtureResponseDTO>>(BASE_URL, data),
  getBySeasonId: (
    seasonId: string,
    params?: Omit<FixtureQueryDTO, "seasonId">,
  ) =>
    api.getWithParams<ApiResponse<FixturesPaginatedResponseDTO>>(
      BASE_URL,
      {
        ...params,
        seasonId,
      },
    ),
  getById: (id: string) =>
    api.get<ApiResponse<FixtureResponseDTO>>(`${BASE_URL}/${id}`),
  getPaginate: (params?: FixtureQueryDTO) =>
    api.getWithParams<ApiResponse<FixturesPaginatedResponseDTO>>(
      BASE_URL,
      params,
    ),
  update: (id: string, data: UpdateFixtureRequestDTO) =>
    api.patch<ApiResponse<FixtureResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
  importFromCatalog: (data: ImportFixturesFromCatalogRequestDTO) =>
    api.post<ApiResponse<ImportFixturesFromCatalogResponseDTO>>(
      `${BASE_URL}/import`,
      data,
    ),

  getKnockoutTree: (seasonId: string) =>
    api.getWithParams<ApiResponse<KnockoutTreeResponseDTO>>(BASE_URL + "/knockout-tree", {
      seasonId,
    }),

  getWithPredictions: (params: FixtureWithPredictionQueryDTO) =>
    api.getWithParams<ApiResponse<FixturesWithPredictionsPaginatedResponseDTO>>(
      `${BASE_URL}/with-predictions`,
      params,
    ),
};
